export const GA_ACCOUNT = 'G-5FZ1HNQ4NB'

export const ANALYTICS__FAILURE = 'analyticsFailure'
export const ANALYTICS__SUCCESS = 'analyticsSuccess'
